<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="">お知らせ</h1>
      <div class="l-contentsBox has-rightbtn">
        <div v-if="$route.name === 'notice-edit'" class="btn-contentsdelete" @click="deleteNotice()">
          <a><img src="@/assets/img/common/icon-x.svg" alt="">このお知らせを削除する</a>
        </div>
        <table class="l-form-table">
          <tr>
            <th class="v-middle"><span>有効期間</span></th>
            <td class="v-middle">
              <div class="l-inputDate" style="padding-left: 10px;">
                <DatePicker v-model="$v.inputForm.$model.fromDt" :value="this.inputForm.fromDt"></DatePicker>
                <ValidationErrorMessage v-show="$v.inputForm.fromDt.$error && !$v.inputForm.fromDt.required" validation="required" />
              </div>
              <span style="padding-left: 10px;">〜</span>
              <div class="l-inputDate" style="padding-left: 20px;">
                <DatePicker v-model="$v.inputForm.$model.toDt" :value="this.inputForm.toDt" :clearButton="true"></DatePicker>
              </div>
            </td>
          </tr>
          <tr v-if="isSystemAdmin">
            <th class="v-middle"><span>対象プラン</span></th>
            <td class="v-middle">
              <div>
                <template v-for="(plan) in planList">
                  <label class="l-checkbox" :key="plan.planId">
                    <input type="checkbox"
                      :value="$v.inputForm.$model.mailSendTargetPlan.includes(plan.planId)"
                      :checked="$v.inputForm.$model.mailSendTargetPlan.includes(plan.planId)"
                      @change="selectPlan(plan.planId)" />
                    {{ plan.name }}
                  </label>
                </template>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.mailSendTargetPlan.$error && !$v.inputForm.mailSendTargetPlan.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メール送信</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.inputForm.$model.mailSendKbn"
                  name="inputForm.mailSendKbn"
                  :options="selectMailSendKbnList"
                  :selectedValue="inputForm.mailSendKbn">
                </SelectBox>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.mailSendKbn.$error && !$v.inputForm.mailSendKbn.required" validation="required" />
            </td>
          </tr>
          <tr v-if="$v.inputForm.$model.mailSendKbn == 1">
            <th class="v-middle"><span>メール配信予定日時</span></th>
            <td class="v-middle">
              <div class="l-inputDate" style="padding-left: 20px;">
                <DatePicker v-model="mailSendDate"></DatePicker>
                <TimePicker v-model="mailSendTime"></TimePicker>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.mailSendTs.$error && !$v.inputForm.mailSendTs.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お知らせ種別</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.inputForm.$model.noticeType"
                  name="inputForm.notice_type"
                  :options="selectNoticeTypeList"
                  :selectedValue="inputForm.noticeType"
                ></SelectBox>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.noticeType.$error && !$v.inputForm.noticeType.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お知らせ対象</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.inputForm.$model.mailSendTarget"
                  name="inputForm.mail_send_target"
                  :options="selectMailSendTargetList"
                  :selectedValue="inputForm.mailSendTarget">
                </SelectBox>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.mailSendTarget.$error && !$v.inputForm.mailSendTarget.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>タイトル</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.inputForm.$model.title" @input="$v.inputForm.$touch()" />
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.title.$error && !$v.inputForm.title.required" validation="required" />
              <ValidationErrorMessage v-show="$v.inputForm.title.$error && !$v.inputForm.title.maxLength" validation="maxLength"  valueLength="100" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お知らせ内容</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextArea v-model="$v.inputForm.$model.content" @input="$v.inputForm.$touch()" class="l-formGroup__textArea" />
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.content.$error && !$v.inputForm.content.required" validation="required" />
              <ValidationErrorMessage v-show="$v.inputForm.content.$error && !$v.inputForm.content.maxLength" validation="maxLength"  valueLength="600" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>添付ファイル</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px; padding-right: 20px;">{{ this.fileName }}</span>
              <input type="file" v-on:change="fileSelected">
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>プレビューファイル</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px; padding-right: 20px;">{{ this.inputForm.imageFileName }}</span>
              <input type="file" v-on:change="previewFileSelected">
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-noborder is-inlne js-cancel" @click="goNoticeList()"><a>一覧へ戻る</a></div>
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>登録</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import DatePicker from '@/components/parts/form/DatePicker.vue';
import TimePicker from '@/components/parts/form/TimePicker.vue';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import constant from '@/const';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import moment from 'moment';

export default {
  components: {
    Loading,
    SelectBox,
    TextBox,
    TextArea,
    DatePicker,
    TimePicker,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      mailSendDate: null,  // DatePicker用
      mailSendTime: '',  // TimePicker用
      inputForm: {
        noticeType: 2,
        fromDt: null,
        toDt: null,
        mailSendKbn: 0,
        mailSendTarget: 4,
        mailSendTs: null,
        title: '',
        content: '',
        imageFileName: null,
        mailSendTargetPlan: [],
      },
      file: {
        fileNm: ''
      },
      fileInfo: '',
      previewFile: {
        fileNm: ''
      },
      previewFileInfo: '',
      selectMailSendKbnList: constant.MAIL_SEND_KBN,
      selectNoticeTypeList: constant.NOTICE_TYPE,
      isSystemAdmin: false,
      isAllPermission: false,
      planList: [
        {
          planId: null,
          value: null,
          label: '',
          planOptions: [
            {
              planOptionId: null,
              name: ''
            }
          ]
        }
      ],
      currentPlanId: null,
    }
  },
  validations: {
    inputForm: {
      noticeType: { required },
      fromDt: { required },
      mailSendKbn: { required },
      mailSendTarget: { required },
      mailSendTs: {
        required: requiredIf(function (model) {
          return this.inputForm.mailSendKbn == 1 && model;
        })
      },
      title: { required, maxLength: maxLength(100) },
      content: { required, maxLength: maxLength(600) },
      mailSendTargetPlan: { required },
    }
  },
  computed: {
    selectMailSendTargetList() {
      if (this.isSystemAdmin || this.isAllPermission) return constant.MAIL_SEND_TARGET;
      let list = constant.MAIL_SEND_TARGET.filter(mst => {
        return mst.value == 4;  // 管理下の一般ユーザすべて
      });
      return list;
    },
    fileName() {
      return this.file ? this.file.fileNm : '';
    },
    previewFileName() {
      return this.previewFile ? this.previewFile.fileNm : '';
    },
    noticeId() {
      return this.$store.getters['portal/getNoticeId'];
    },
    isNew() {
      return this.$route.name === 'notice-new';
    }
  },
  watch: {
    // mailSendDateまたはmailSendTimeが変更されたらmailSendTsを更新
    mailSendDate() {
      this.updateMailSendTs();
    },
    mailSendTime() {
      this.updateMailSendTs();
    }
  },
  created: async function() {
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.planList = await this.getPlanList();
    this.currentPlanId = await this.getCurrentPlan();
    if (this.$route.name === 'notice-edit') {
      await this.getNotice(this.noticeId);
    }
    else if(!this.isSystemAdmin) {
      // システム管理ユーザー以外の場合、新規作成時に自身のプランを設定しておく
      // ※全権限はお知らせを追加できないので条件に入れない
      this.inputForm.mailSendTargetPlan = [this.currentPlanId];
    }
    this.isProcessing = false;
  },
  methods: {
    async getNotice(noticeId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/notice/getNotice', {
        noticeId: noticeId,
      });
      if (res) {
        this.inputForm = res.data.notice;
        this.file = res.data.notice.file;
        
        // mailSendTsをmailSendDateとmailSendTimeに分割
        if (this.inputForm.mailSendTs) {
          const dt = moment(this.inputForm.mailSendTs);
          this.mailSendDate = dt.format('YYYY-MM-DD');
          this.mailSendTime = dt.format('HH:mm');
        }
      }
      this.isProcessing = false;
    },
    async getCurrentPlan() {
      this.isProcessing = true;
      const res = await this.$axios.get('/ld/api/notice/getCurrentPlanId');
      this.isProcessing = false;
      return res ? res.data.currentPlanId : null;
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    previewFileSelected(event) {
      this.previewFileInfo = event.target.files[0];
    },
    goNoticeList() {
      this.$router.push({ name: 'notice-list' });
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        if ( this.isNew ) {
          const answer = window.confirm("【注意！】この情報は管理下の一般ユーザ全てに表示されます。本当に登録しますか？");
          if (!answer) return false;
        }

        this.isProcessing = true;
        const formData = new FormData()
        formData.append('file', this.fileInfo)
        formData.append('previewFile', this.previewFileInfo);
        formData.append('notice', JSON.stringify(this.inputForm))
        if (this.noticeId) {
          formData.append('noticeId', this.noticeId)
        }
        let res = await this.$axios.post('/ld/api/notice/store', formData);
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '登録が完了しました');
          this.$router.push({ name: 'notice-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    async deleteNotice() {
      if (window.confirm("削除しますか？")) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/notice/delete', {
          noticeId: this.noticeId,
        });
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '削除しました');
          this.$router.push({ name: 'notice-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    async getPlanList() {
      this.isProcessing = true;
      const res = await this.$axios.post('/ld/api/notice/getPlanList', {});
      this.isProcessing = false;
      return res ? res.data.planList : null;
    },
    selectPlan(planId) {
      if (this.$v.inputForm.$model.mailSendTargetPlan.includes(planId)) {
        this.$v.inputForm.$model.mailSendTargetPlan = this.$v.inputForm.$model.mailSendTargetPlan.filter(pid => pid !== planId);
      }
      else {
        this.$v.inputForm.$model.mailSendTargetPlan.push(planId);
      }
    },
    updateMailSendTs() {
      // mailSendDateとmailSendTimeを組み合わせてmailSendTsを生成
      if (this.mailSendDate && this.mailSendTime) {

        const date = moment(this.mailSendDate).format('YYYY-MM-DD');
        const time = (this.mailSendTime)
        
        this.inputForm.mailSendTs = `${date} ${time}`;

      } else if (this.mailSendDate) {
        // 日付のみの場合は00:00:00をセット
        this.inputForm.mailSendTs = moment(this.mailSendDate).format('YYYY-MM-DD') ;
      } else {
 
        this.inputForm.mailSendTs = null;
      }
    }
  }
}

</script>
